import React from 'react';
import { IconProps } from '.';

const SvgFilterFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M20.595 3.248c1.06 0 1.625 1.226.979 2.028l-.067.077-7.19 7.671a.251.251 0 0 0-.068.171v7.017l-.414.207-4.086 2.05v-9.274a.251.251 0 0 0-.039-.133l-.028-.038-7.19-7.671c-.748-.799-.182-2.105.912-2.105h17.191Z'
      />
    </svg>
  );
};

export default SvgFilterFill;
